'use client'

/**
 * Herlogin-flow bij een verlopen sessie (FO-374 C).
 *
 * Verschijnt zodra `markSessionExpired()` is aangeroepen (een authed poll/SSE zag
 * een 401/403). Toont een blokkerende melding met een knop naar de bestaande
 * login-flow i.p.v. de gebruiker stil te laten doorwerken op een dode sessie.
 *
 * Bewust een volledige navigatie (`<a href>`, geen client-router): dat gooit de
 * stale client-state weg en laat de middleware de Entra-herauthenticatie starten.
 */
import { useSessionExpired } from '@/lib/session-expired'

export function SessionExpiredNotice() {
  const expired = useSessionExpired()
  if (!expired) return null

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="session-expired-title"
      aria-describedby="session-expired-desc"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 p-4"
    >
      <div className="w-full max-w-sm rounded-lg border border-streep-border bg-streep-surface p-6 shadow-xl">
        <h2 id="session-expired-title" className="text-lg font-semibold text-streep-donker">
          Sessie verlopen
        </h2>
        <p id="session-expired-desc" className="mt-2 text-sm text-streep-text-muted">
          Je bent uitgelogd of je sessie is verlopen. Log opnieuw in om verder te gaan.
        </p>
        <a
          href="/login"
          className="mt-5 inline-flex min-h-11 w-full items-center justify-center rounded-md bg-streep-groen px-4 text-sm font-semibold text-streep-donker transition-opacity hover:opacity-90"
        >
          Opnieuw inloggen
        </a>
      </div>
    </div>
  )
}
